




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Container, Draggable } from 'vue-smooth-dnd';
import { IContent, IScenario } from '../models';
import { CollectionNames } from '../services/meiosis';
import KanbanCard from './kanban-card.vue';
import AddComponentCard from './add-component-card.vue';

@Component({
  components: { Container, Draggable, KanbanCard, AddComponentCard },
})
export default class KanbanList extends Vue {
  @Prop({ default: '' }) public itemkey!: CollectionNames;
  @Prop({ default: false }) private readonly verticalDirection!: boolean;
  private items: Partial<IContent>[] = [];
  private title = '';
  private language = '';
  private menu = false;
  private includedComponents: string[] = [];

  @Watch('itemkey')
  private itemkeyChanged() {
    this.init();
  }

  @Watch('language')
  private languageChanged() {
    this.setTitle();
  }

  constructor() {
    super();
  }

  private async setTitle() {
    if (!this.itemkey || !this.itemkey.length) return;
    this.title = this.$tc(`COMP.${this.itemkey.toLocaleUpperCase()}`, 1) || this.itemkey;
  }

  private init() {
    if (!this.itemkey || !this.itemkey.length) return;
    this.setTitle();
    this.$store.actions[this.itemkey].updateList();
    let scenario: Partial<IScenario> | undefined;
    this.$store.states.map(s => {
      if (!s[this.itemkey]) return;
      this.items = s[this.itemkey].list || [];
      this.language = s.app.language;
      scenario = s.scenarios.current;
    });
    this.extractUsedComponents(scenario);
  }

  private async closeMenu() {
    this.menu = false;
  }

  private extractUsedComponents(scenario?: Partial<IScenario>) {
    this.includedComponents =
      this.itemkey && scenario && scenario.narratives && scenario.narratives.length
        ? scenario.narratives.filter(n => n.included).map(n => n.components[this.itemkey])
        : [];
  }

  /** Called when the KanbanCard is dropped */
  private onDrop(dropResult: { removedIndex: number; addedIndex: number; payload: unknown; element: HTMLElement }) {
    const { removedIndex, addedIndex } = dropResult;
    if (removedIndex === addedIndex) return;
    this.items.splice(addedIndex, 0, this.items.splice(removedIndex, 1)[0]);
    this.$store.actions[this.itemkey].saveList(this.items);
  }

  mounted(): void {
    console.log(`KanbanList mounted`);
    this.init();
  }
}
